import { Component, OnInit, Input } from '@angular/core';
import { DraftManagerService } from '../draft-manager.service';

@Component({
  selector: 'app-draft-timer',
  templateUrl: './draft-timer.component.html',
  styleUrls: ['./draft-timer.component.scss']
})
export class DraftTimerComponent implements OnInit {

  /** @var {number[]} Shows [seconds, minutes] passed */
  public timer = [30,0];
  public timerText = "0:30";
  public descText: string = "Free Draft";
  public draftType: string;
  public phase = {name: "none"};
  public pause = false;
  public ongoing = false;

  constructor(
    private draftManagerService: DraftManagerService
  ) { }

  ngOnInit() {
    this.draftManagerService.draftTimerComponent = this;
  }

  ngAfterViewInit() {
    this.startTimer();
  }

  startTimer() {
    this.pause = false;
    this.phase = this.draftManagerService.phase;
    setInterval(() => {
      if (!this.pause) {
        this.timer[0] -=1;
        if (this.timer[0] <= -60) {
          this.timer[0] = 0;
          this.timer[1] -= 1;
        }
        this.setTimerText();
      }
    }, 1000);
  }

  stopTimer() {
    this.pause = true;
  }

  resetTimer() {
    this.timer = [30,0];
    this.setTimerText();
  }

  endTimer() {
    this.descText = "Free Draft"
    if (this.draftManagerService.draftType === "free")
      this.phase['name'] = "Free Draft";
  }

  setTimerText() {
    if (this.descText === "End of Draft") {
      this.timerText = "0:00";
      this.stopTimer();
      this.timer = [0, 0];
      return;
    }
    var text = "";
    if (this.timer[0] < 0 || this.timer[1] < 0)
      text += "-"
    if (this.timer[1] < 0)
      text += this.timer[1]*(-1);
    else
      text += this.timer[1];
    text += ":";
    if (this.timer[0] < 10 && this.timer[0] > -10)
      text += "0";
    if (this.timer[0] < 0)
      text += this.timer[0]*(-1);
    else
      text += this.timer[0];
    this.timerText = text;
  }

}
